import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Rola suavemente até a seção indicada pela âncora (#secao) sempre que a URL
// tem hash — inclusive quando a seção pertence a OUTRA página.
//
// Ex.: estando em /empresa, o link "/#segmentos" leva para a Home e rola até
// a seção "Segmentos". Como as seções podem renderizar um pouco depois
// (carregamento sob demanda), tentamos localizar o elemento por alguns instantes.
export default function HashScrollHandler() {
  const location = useLocation();

  useEffect(() => {
    const id = decodeURIComponent(location.hash.replace(/^#/, ""));
    if (!id) return;

    let cancelled = false;
    let attempts = 0;

    const tryScroll = () => {
      if (cancelled) return;
      const element = document.getElementById(id);
      if (element) {
        // Compensa a barra de navegação fixa para não esconder o título.
        const offset = window.innerWidth >= 768 ? 96 : 80;
        const top = element.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: "smooth" });
        return;
      }
      attempts += 1;
      if (attempts < 60) window.setTimeout(tryScroll, 80);
    };

    // requestAnimationFrame garante que roda após o roteador ajustar o topo.
    const raf = window.requestAnimationFrame(tryScroll);
    return () => {
      cancelled = true;
      window.cancelAnimationFrame(raf);
    };
  }, [location.pathname, location.hash, location.key]);

  return null;
}